var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"last-read-break"},[_c('div',{staticClass:"break-line"}),_c('div',{staticClass:"break-content"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"blue"}},[_vm._v("mdi-check-all")]),_c('span',{staticClass:"break-text"},[_vm._v(_vm._s(_vm.breakText))])],1),_c('div',{staticClass:"break-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }